<template>
    <div>
        <rkm-table
            v-if="!readonly"
            :fields="fields"
            :items="data.model.problemasCondicoes"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(ciap)="{item}">
                {{item.ciap ? `${item.ciap.codigo} - ${item.ciap.descricao}` : ''}}
            </template>

            <template v-slot:cell(cid)="{item}">
                {{item.cid ? `${item.cid.codigo} - ${item.cid.nome}` : ''}}
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <rkm-area
            :closed="!readonly"
            background-color="primary"
            title="Histórico de problemas e/ou condições resolvidos em atendimentos anteriores"
            type="box"
        >
            <rkm-list
                :items="data.form.problemasCondicoes"
                hide-filters
                hide-pagination
            >
                <template v-slot="{item}">
                    <rkm-row>
                        <rkm-col>
                            <strong>Data / Hora</strong><br />{{item.dataHora}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Setor</strong><br />{{item.centroCusto.setor.nome}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Profissional</strong><br />{{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}
                        </rkm-col>
                    </rkm-row>

                    <hr />

                    <rkm-row>
                        <rkm-col cols="4">
                            <strong>CIAP 2</strong><br />{{item.ciap ? `${item.ciap.codigo} - ${item.ciap.descricao}` : ''}}
                        </rkm-col>

                        <rkm-col cols="4">
                            <strong>CID 10</strong><br />{{item.cid ? `${item.cid.codigo} - ${item.cid.nome}` : ''}}
                        </rkm-col>

                        <rkm-col cols="2">
                            <strong>Início</strong><br />{{item.inicio.data}}
                        </rkm-col>

                        <rkm-col cols="2">
                            <strong>Fim</strong><br />{{item.fim.data}}
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:collapse="{item}">
                    <rkm-row class="p-2">
                        <rkm-col>
                            {{item.observacao ? item.observacao : '-'}}
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-list>
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

export default {
    components: {Modal},
    data: () => ({
        fields: [
            {key: 'ciap', label: 'CIAP 2', sortable: true},
            {key: 'cid', label: 'CID 10', sortable: true},
            {key: 'inicio.data', label: 'Início', sortable: true},
            {key: 'fim.data', label: 'Fim', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o problema/condição?', async () => {
                this.data.model.problemasCondicoes.splice(index, 1)
            })
        },
    },
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, required: true},
    },
}
</script>